const audio = new Audio(
  "https://cdn.freesound.org/previews/564/564623_3784934-lq.mp3"
);

export const getNotification = (currentStage, nextStage) => {
  const stageName = currentStage === "Relax" ? "Pomodoro" : currentStage;
  const bodyText =
    currentStage === "Relax"
      ? "Start another cycle?"
      : `Time to ${nextStage.toLowerCase()}`;

  new Notification(`${stageName} over!`, {
    body: bodyText,
    icon: "favicon.png",
    badge: "favicon.png",
  });
  audio.play();
};
